import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, MenusActionCreator, AdditionalServicesActionCreator, WebOpsActionCreator, CustomerActionCreator, RepairOrdersActionCreator, RMTimesActionCreator, SpecsActionCreator, VehiclesActionCreator } from 'src/store/states';
import Summary from '../Summary';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    appointment: state.Appointment,
    specData: state.Specs,
    viewMode: state.Framework.viewMode,
    vehiclePhoto: state.Vehicles.vehiclePhoto,
    profile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    vehPhotoList: state.Vehicles.vehPhotoList,
    previewFlag: state.Framework.previewFlag,
    theme: state.Framework.theme,
    textCheckReturned: state.Customer?.textCheckReturned,
    textOptIn: state.Customer.Customer?.textOptIn,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    gmTrackingFlag: state.Specs.specs?.gmTrackingFlag ?? '',
    additionalServices: state.AdditionalServices,
    loadAppt: state.Framework.loadAppt,
    individualServices: state.WebOps.WebOps,
    menus: state.Menus.allMenus.menus,
    custError: state.Customer?.errMsg,
    customerInfo: state.Customer.Customer,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    specProfile: state.Framework.specProfile,
    locale: state.Framework.locale,
    profileOpen: state.Framework.profileOpen,
    selectedVehicle: state.Vehicles.selectedVehicle!,
    newVehicleMileage: state.NewVehicle.NewVehicle?.estMileage!,
    decodeErr: state.Vehicles.decodedData.decodeErr,
    prevMileage: state.Vehicles.selectedVehicle !== 'AddVehicle' && state.Vehicles.selectedVehicle &&
        state.Vehicles.selectedVehicle !== '' && state.Vehicles ? state.Vehicles.selectedVehicle !== '-1' &&
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!] &&
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!].prevMileage : 0,
    smsLaunched: state.Framework.smsLaunched ? state.Framework.smsLaunched : '',
    identityVerified: state.Customer.identityVerified,
    skipServices: !(state.Specs.specs?.skipServicesFlag ?? false) && !(state.Specs.specs?.showWrtYourOwn ? true : false) &&
        !(state.Specs.specs?.showDiagnTool ? true : false) && state.WebOps.WebOps?.length === 0 &&
        state.Menus.allMenus.menus.length === 0,
    maintContracts: state.AdditionalServices.maintContractData.maintContracts,
    apptDept: state.Appointment.Appointment.department,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    vehicles: state.Vehicles.vehicles,
    apptAdvNum: state.Appointment.Appointment.advisor,
    invalidDates: state.RMTimes.invalidDates,
    invalidDatesDept: state.RMTimes.invalidDatesDept,
    lastDeptRan: state.QuickTimes.lastDeptRan,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    apptOps: state.Appointment.ApptOps,
    deptChangeFlag: state.Appointment.deptChangeFlag ?? false,
    employeeFlag: state.Customer.Customer.employeeFlag ?? false,
    gmRedeemAmt: state.Appointment.Appointment.department !== 'B' ? state.Customer.Customer.gmRedeemAmt : '',
    gmMemberErr: state.Customer.gmMemberErr,
    gmRewardsLoading: state.Customer.gmRewardsLoading,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    gmDealerCanEarn: state.Appointment.Appointment.department !== 'B' ? state.Specs.specs?.gmDealerCanEarn : '',
    gmDealerCanRedeem: state.Appointment.Appointment.department !== 'B' ? state.Specs.specs?.gmDealerCanRedeem : '',
    Itype: state.Framework.ImageServerType,
    TMNAMileage: state.AdditionalServices.maintContractData.TMNAMileage,
    changeCustReturned: state.Customer.changeCustReturned,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    idkMileage: state.Framework.idkMileage,
    hidePriceLabel: state.Specs.specs?.hidePriceLabel,
    vwTrackingFlag: state.Specs.specs?.vwTrackingFlag ?? '',
    sessionId: state.Framework.sessionId,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    updateApptCust: AppointmentActionCreator.UpdateApptCust,
    updateApptVeh: AppointmentActionCreator.UpdateApptVehicle,
    createAppt: AppointmentActionCreator.CreateAppt,
    editAppt: AppointmentActionCreator.EditAppt,
    updateVehicleMileage: AppointmentActionCreator.UpdateApptVehicleMileage,
    clearError: AppointmentActionCreator.ClearApptError,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    toggleMenu: MenusActionCreator.ToggleMenu,
    toggleWeOwe: AdditionalServicesActionCreator.ToggleWeOwe,
    toggleRecommended: AdditionalServicesActionCreator.ToggleRecommended,
    toggleRecall: AdditionalServicesActionCreator.ToggleRecall,
    toggleItem: WebOpsActionCreator.ToggleItems,
    getCustAppts: AppointmentActionCreator.GetCustAppts,
    checkPhoneOptIn: CustomerActionCreator.CheckPhoneOptIn,
    clearTextCheckReturned: CustomerActionCreator.ClearTextCheckReturned,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    ClearTokenData: FrameworkActionCreator.ClearTokenData,
    clearCheckedWebOps: WebOpsActionCreator.ClearCheckedWebOps,
    clearCheckedAdditionalServices: AdditionalServicesActionCreator.ClearCheckedAdditionalServices,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    clearMenusState: MenusActionCreator.ClearMenusState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    setScheduleOption: MenusActionCreator.SetScheduleOption,
    setMileageOption: MenusActionCreator.SetMileageOption,
    clearCustError: CustomerActionCreator.CustomerClearError,
    checkUniqueEmail: CustomerActionCreator.CheckUniqueEmail,
    cancelAppt: AppointmentActionCreator.CancelAppt,
    getMenus: MenusActionCreator.GetMenus,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    getApptOps: WebOpsActionCreator.GetApptOps,
    onApptCustUpdate: AppointmentActionCreator.UpdateApptCust,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    determineDept: AppointmentActionCreator.DetermineDept,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    clearRMTimes: RMTimesActionCreator.ClearRMTimes,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    changeDeptFlag: AppointmentActionCreator.SetChangeDeptFlag,
    updateEmployeeChanges: AppointmentActionCreator.UpdateEmployeeChanges,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
    changeCustInfo: CustomerActionCreator.ChangeCustInfo,
    setChangeCustReturned: CustomerActionCreator.SetChangeCustReturned,
    clearOnlyAppointmentState: AppointmentActionCreator.ClearOnlyApptState,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    decodeVin: VehiclesActionCreator.DecodeVin,
    setIdkMileage: FrameworkActionCreator.SetIdkMileage,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Summary);